var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 53,
    viewBox: "0 0 55 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_516_12268)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.04199,
    y: 2.5,
    width: 40.8321,
    height: 39.2239,
    fill: "#78C0AB",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.7357C31.3381 17.029 30.627 17.2272 29.8794 17.3168C30.6508 16.8553 31.2278 16.1289 31.503 15.2731C30.7783 15.7036 29.9851 16.0066 29.158 16.1689C28.6018 15.575 27.8651 15.1814 27.0623 15.0491C26.2594 14.9169 25.4354 15.0534 24.7181 15.4374C24.0007 15.8215 23.4303 16.4316 23.0953 17.1731C22.7602 17.9146 22.6794 18.7459 22.8652 19.5381C21.3968 19.4643 19.9603 19.0827 18.649 18.4178C17.3376 17.753 16.1807 16.8199 15.2533 15.679C14.9362 16.226 14.7539 16.8602 14.7539 17.5356C14.7535 18.1436 14.9033 18.7423 15.1898 19.2786C15.4763 19.8149 15.8908 20.2722 16.3965 20.6099C15.81 20.5912 15.2366 20.4327 14.7238 20.1477V20.1952C14.7237 21.048 15.0187 21.8746 15.5587 22.5346C16.0987 23.1947 16.8504 23.6476 17.6863 23.8165C17.1423 23.9637 16.5719 23.9854 16.0183 23.8799C16.2542 24.6137 16.7136 25.2553 17.3322 25.7151C17.9508 26.1748 18.6977 26.4295 19.4683 26.4436C18.1602 27.4706 16.5446 28.0276 14.8815 28.0252C14.5869 28.0252 14.2926 28.008 14 27.9736C15.6881 29.059 17.6532 29.6351 19.6602 29.6328C26.454 29.6328 30.168 24.006 30.168 19.1258C30.168 18.9673 30.164 18.8072 30.1569 18.6486C30.8793 18.1262 31.5029 17.4792 31.9984 16.7381L32 16.7357V16.7357Z",
    fill: "#F8F8F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_516_12268",
    x: 0.541992,
    y: 0,
    width: 53.832,
    height: 52.2239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_516_12268"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_516_12268",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8821893a1ae525526642705cafde13a3.svg";
export { ForwardRef as ReactComponent };